<template>
    <div class="table">
        <div class="container">
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-select v-model="form.deptId" placeholder="请选择学校">
                        <el-option
                            v-for="item in depts"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-input v-model="form.className" placeholder="班级名称"></el-input>
                </div>
            </div> 
            &nbsp;
            <el-button type="primary" icon="search" @click="getData()">查询</el-button>
            
            <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="roleId"
                v-loading="loading"
                element-loading-background = "rgba(255, 255,255,0.7)"
                element-loading-text = "数据正在加载中..."
                border
                default-expand-all>
                <!-- <el-table-column type="selection" width="55" :selectable="selectable"></el-table-column> -->
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                <el-table-column prop="className" label="班级名称"   :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="deptControllerName" label="班主任"  width="110" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column fixed="right" label="操作" width="100px" style="text-align:'left'">
                    <template slot-scope="scope">
                        <el-button  @click.native.prevent="findUser(scope.row)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">设置班主任 </span>
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div> 
        <!-- 人员弹出框 -->
        <div v-if="transferVisible">
            <userTransfer ref="userTransfer"></userTransfer>
        </div>
    </div>
</template>

<script>
    import http from '../../../../common/http'; 
    import userTransfer from '../../sys/user/UserTransfer.vue';

    export default {
        data(){
            return{
                loading:false,
                transferVisible:false,
                form:{
                    id:"",
                    deptId:"",
                    className:""
                },
                data:[],
                depts:[]
            }
        },
        components: {
            userTransfer
        },
        created:function () {
            this.getDeptData();
        },
        methods:{
            indexMethod(index) {
                return index+1;
            },
            getDeptData(){
                //部门管理
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.depts=res.data.list;
                        if(this.depts.length>0){
                           this.form.deptId=this.depts[0].id;
                        }
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getData(){
                this.loading=true;
                let url  = this.listSetClassUrl;
                let data = {
                    deptId:this.form.deptId,
                    className:this.form.className
                };
                this.apiPost(url,data).then((res) => {
                    if(res.status == 200){
                       this.data = res.data;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                });
            },
            selectable(row){
                if(row.id == 1){
                    return false;
                }else{
                    return true;
                }
            },
            findUser(row){
                this.form.id=row.classId;
                this.transferVisible=true;
                this.$nextTick(() => {
                    if(this.$util.isNotEmpty(row.deptController)){
                        let val=new Array();
                        val.push(row.deptController);
                        this.$refs['userTransfer'].init(2,val,1,this.form.deptId);
                    }else{
                        this.$refs['userTransfer'].init(2,null,1,this.form.deptId);
                    }
                })
            },
            setUser(key,label){
                let data = {
                    id:this.form.id,
                    deptController:key
                };
                let url  = this.deptSetClassMasterUrl;
                this.loading=true;
                this.apiPost(url,data).then((res) => {
                    if(res.status == 200){
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                });
            } 
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/mobileset/classmaster/classMaster.vue